import { useEffect, useState } from "react";
import { Menu, X, ShoppingBag } from "lucide-react";
import { useCart } from "../../context/CartContext";

const links = [
  { href: "#despre-noi", label: "Despre Noi" },
  { href: "#catalog", label: "Catalog" },
  { href: "#beneficii", label: "Beneficii" },
  { href: "#contact", label: "Contact" },
];

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { totalQty, setOpen: setCartOpen } = useCart();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    // If we're not on the home page, navigate first
    if (window.location.pathname !== "/") {
      window.location.href = "/" + href;
      return;
    }
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      data-testid="navigation-menu"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#080706]/85 backdrop-blur-xl border-b border-[#1F1A18]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 flex items-center justify-between h-20">
        <button
          onClick={() => scrollTo("#hero")}
          data-testid="brand-logo"
          className="flex flex-col items-start leading-none text-left"
        >
          <span className="font-[Playfair_Display] text-[#FDF8F5] text-lg tracking-[0.18em] uppercase">
            Produse Alimentare
          </span>
          <span className="font-[Playfair_Display] italic text-[#C8A97E] text-sm tracking-[0.3em] -mt-0.5">
            En Gross
          </span>
        </button>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              onClick={() => scrollTo(l.href)}
              className="text-[#A8A29E] hover:text-[#FDF8F5] text-sm font-light tracking-wide transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-quote"
            onClick={() => scrollTo("#contact")}
            className="bg-[#C8A97E] text-[#080706] px-6 py-3 text-sm font-medium tracking-wide hover:bg-[#B3956D] transition-colors duration-300"
          >
            Cere Ofertă
          </button>
          <button
            data-testid="nav-cart-btn"
            onClick={() => setCartOpen(true)}
            aria-label="Coș"
            className="relative flex items-center justify-center w-11 h-11 border border-[#3D3530] text-[#FDF8F5] hover:border-[#C8A97E] hover:text-[#C8A97E] transition-colors"
          >
            <ShoppingBag size={16} strokeWidth={1.4} />
            {totalQty > 0 && (
              <span
                data-testid="nav-cart-count"
                className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center text-[10px] font-medium bg-[#C8A97E] text-[#080706] rounded-full"
              >
                {totalQty}
              </span>
            )}
          </button>
        </div>

        <div className="flex items-center gap-3 md:hidden">
          <button
            data-testid="nav-cart-btn-mobile"
            onClick={() => setCartOpen(true)}
            aria-label="Coș"
            className="relative flex items-center justify-center w-10 h-10 border border-[#3D3530] text-[#FDF8F5]"
          >
            <ShoppingBag size={16} strokeWidth={1.4} />
            {totalQty > 0 && (
              <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center text-[10px] font-medium bg-[#C8A97E] text-[#080706] rounded-full">
                {totalQty}
              </span>
            )}
          </button>
          <button
            className="text-[#FDF8F5]"
            onClick={() => setOpen((o) => !o)}
            data-testid="mobile-menu-toggle"
            aria-label="Meniu"
          >
            {open ? <X size={26} strokeWidth={1.2} /> : <Menu size={26} strokeWidth={1.2} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#1F1A18] bg-[#080706]/95 backdrop-blur-xl">
          <div className="flex flex-col px-6 py-6 gap-5">
            {links.map((l) => (
              <button
                key={l.href}
                onClick={() => scrollTo(l.href)}
                className="text-left text-[#A8A29E] hover:text-[#FDF8F5] text-base font-light"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => scrollTo("#contact")}
              className="mt-2 bg-[#C8A97E] text-[#080706] px-6 py-3 text-sm font-medium tracking-wide"
            >
              Cere Ofertă
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};
